// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './store/vue-axios'

//Bootstrap styling
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//Theme styles by Inspinia
import './assets/font-awesome/css/font-awesome.css'
import './assets/css/style.css'

//Additional styles
import 'vue-select/dist/vue-select.css';

import VueCookie from 'vue-cookie'
import VueWait from 'vue-wait'
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'

import VueNotification from 'vue-notification'

import i18n from './lang'
import User from "@/store/models/user"
import formatPriceMixin from "@/mixins/formatPriceMixin"
import formatGermanNumberMixin from "@/mixins/formatGermanNumber"
import Vue2Filters from 'vue2-filters'

import {ApiRoutesModel} from "@/store/models/layout/api_routes";
import {UserConfigDefaults} from "@/store/models/layout/user_config";

const chartjs = require('chart.js')
Vue.use(require('vue-chartjs'),{chartjs})

const moment = require('moment')
require('moment/locale/de')
Vue.use(require('vue-moment'),{moment})

Vue.use(VueCookie)
Vue.use(VueWait)
Vue.use(VueNotification)
Vue.use(BootstrapVue)

Vue.mixin(formatPriceMixin)
Vue.mixin(formatGermanNumberMixin)

Vue.mixin({
  computed: {
    $currentUser() {
      console.log('CU 0')
      const x = User.currentUser()
      return x
    },
    $userConfig(){
      return Object.assign({},UserConfigDefaults.find(this.$currentUser.$id))
      // const x = UserConfigDefaults.find(this.$currentUser.$id)
      // return x
    }
  }
})

Vue.component('v-select', vSelect)
Vue.component('ValidationProvider', ValidationProvider)

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  wait: new VueWait({
    useVuex: true
  }),
  axios,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

// API ROUTES MODEL
//// CHECK IF API ROUTES IS LOADED
const apiRouteModelCheck = ApiRoutesModel.all() && ApiRoutesModel.all().length === 0 ? ApiRoutesModel.fetchApiRoutes() : 'Api_Routes_Model_Loaded'
const globalChanges = ""


// FORMATTER FILTER

const Vue2FiltersConfig = {

  currency: {
    symbol: '€',
    decimalDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true
  }
}


Vue.use(Vue2Filters,Vue2FiltersConfig)



// WEBPACK FOOTER //
// ./src/main.js